import type { Map as MapType, MapLayerMouseEvent } from "maplibre-gl";
import type { MapEventBus } from "../core/MapEventBus";
import type { InteractionHandler } from "./types";
import { LAYERS } from "../layers/constants";

export class SilosClickHandler implements InteractionHandler {
  readonly name = "silo-click";
  private map: MapType | null = null;

  initialize(map: MapType, eventBus: MapEventBus): void {
    this.map = map;

    // Click on silo
    map.on("click", LAYERS.SILOS, (e: MapLayerMouseEvent) => {
      e.preventDefault();

      if (!e.features || e.features.length === 0) return;

      const feature = e.features[0];
      const silo_id = feature?.properties?.silo_id;

      if (silo_id) {
        console.log("[SiloClickHandler] Silo clicked:", silo_id);

        eventBus.emit("silo:clicked", {
          silo_id,
          properties: feature.properties,
        });
      }
    });
  }

  destroy(): void {
    // MapLibre automatically removes listeners when map is destroyed
    this.map = null;
  }
}
